import { render } from "./SimpleTextArea.vue?vue&type=template&id=71ddc588"
import script from "./SimpleTextArea.vue?vue&type=script&lang=js"
export * from "./SimpleTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__